import { createAction, props } from '@ngrx/store'
import { KnowledgeAPIModel, PaginatedAPI } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const view_knowledge_action = createAction(`${actionPrefix} view_knowledge_action`, props<{ id: string }>())

export const view_knowledge_success_action = createAction(
  `${actionPrefix} view_knowledge_success_action`,
  props<{ knowledge: KnowledgeAPIModel }>()
)

export const search_knowledge_success_action = createAction(
  `${actionPrefix} search_knowledge_success_action`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)

export const search_knowledge_action = createAction(
  `${actionPrefix} search_knowledge_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: KnowledgeAPIModel
    routeTo: string
  }>()
)

export const LOAD_KNOWLEDGE_SUMMARY_DETAILS = createAction(
  `${actionPrefix} load_knowledge_summary_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const LOAD_KNOWLEDGE_SUMMARY_DETAILS_SUCCESS = createAction(
  `${actionPrefix} load_knowledge_summary_details_success`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)

export const load_knowledge_quick_option_details = createAction(
  `${actionPrefix} load_knowledge_quick_option_details`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const load_knowledge_quick_option_details_success = createAction(
  `${actionPrefix} load_knowledge_quick_option_details_success`,
  props<{ knowledge: PaginatedAPI<KnowledgeAPIModel> }>()
)